import { put, call } from 'redux-saga/effects';
import { aflt_skillList, aflt_skillAdd, aflt_skillEdit, aflt_skillUpdate, aflt_skillDelete, updateSkillIndex, skillSuggestion } from '../../../services/settings/affiliates/aflt_skillService';

import * as types from '../../../actions';

export function* aflt_skillListSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(aflt_skillList, payload);
      yield put({ type: types.SKILL_LIST_AFFILIATE_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.SKILL_LIST_AFFILIATE_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
   }
  }

export function* aflt_skillAddSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(aflt_skillAdd, payload);
      yield put({ type: types.SKILL_ADD_AFFILIATE_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.SKILL_ADD_AFFILIATE_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* aflt_skillEditSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(aflt_skillEdit, payload);
    yield put({ type: types.SKILL_EDIT_AFFILIATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.SKILL_EDIT_AFFILIATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* aflt_skillUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(aflt_skillUpdate, payload);
    yield put({ type: types.SKILL_UPDATE_AFFILIATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.SKILL_UPDATE_AFFILIATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* aflt_skillDeleteSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(aflt_skillDelete, payload);
    yield put({ type: types.SKILL_DELETE_AFFILIATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.SKILL_DELETE_AFFILIATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* updateSkillIndexSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(updateSkillIndex, payload);
    yield put({ type: types.UPDATE_SKILL_INDEX_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.UPDATE_SKILL_INDEX_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* skillSuggestionSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(skillSuggestion, payload);
    yield put({ type: types.SKILL_SUGGESTION_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.SKILL_SUGGESTION_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}
